import { render } from "./article-edit.vue?vue&type=template&id=0fef75f8&scoped=true"
import script from "./article-edit.vue?vue&type=script&lang=js"
export * from "./article-edit.vue?vue&type=script&lang=js"

import "./article-edit.vue?vue&type=style&index=0&id=0fef75f8&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YDN\\trunk\\zulin-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fef75f8"]])

export default __exports__